// Typelizer digest 825de2d5bd07ecb405e1d6a0e394a481
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** DELETE /c/:company_id/overview/month_end_connection */
  destroy: (options?: RouteOptions): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/overview/month_end_connection', {}, options),
    method: 'delete',
  }),

  /** POST /c/:company_id/overview/month_end_connection */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/overview/month_end_connection', {}, options),
    method: 'post',
  }),
}
